import PropTypes from 'prop-types';
import React from 'react';
import AEReadmeNewComponent from '../components/ae-readme-new/ae-readme-new.jsx';

const AEReadmeNew = props => (
    <AEReadmeNewComponent onClose={props.onClose} />
);

AEReadmeNew.propTypes = {
    onClose: PropTypes.func.isRequired
};

export default AEReadmeNew;